import { Panel, Stack } from 'rsuite';
import { useLoaderData } from "react-router-dom";
import { Container, Content } from 'rsuite';
import Icon403 from 'src/icons/403';
import Brand from 'src/components/Brand';
import Footer from "src/layout/footer";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const DeclinedPage = () => {
    useLoaderData();
    return /*#__PURE__*/ _jsxs(Container, { children: [/*#__PURE__*/ _jsx(Content, { children: /*#__PURE__*/ _jsxs(Stack, { justifyContent: "center", alignItems: "center", direction: "column", style: { height: '70vh' }, children: [/*#__PURE__*/ _jsx(Brand, { style: { marginBottom: 10 } }), /*#__PURE__*/ _jsx(Panel, { bordered: true, style: { background: '#fff', width: 800 }, children: /*#__PURE__*/ _jsx(Icon403, {}) })] }) }), /*#__PURE__*/ _jsx(Footer, {})] });
};
export default DeclinedPage;
